import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
  const locales = require.context(
    '@/locales',
    true,
    /\.json$/i
  )

  const messages = {}

  locales.keys().forEach((key) => {
    const match = key.match(/([A-Za-z0-9_-]+)\.json$/i)

    if (match) {
      const locale = match[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

const i18n = createI18n({
  legacy: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'fr',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'fr',
  messages: loadLocaleMessages()
})

export default i18n